import(/* webpackMode: "eager", webpackExports: ["AgriNewsList"] */ "/app/apps/next/app/(tabs)/news/agriNewsListPage.tsx");
